// @flow
import { connect } from 'react-redux';
import { selectTemplate } from '~/core/state/recipes/actions';
import TemplatesList from './component';

const mapStateToProps = (state, { producerId, templatesList }) => ({
    producerId,
    templatesList
});

const mapDispatchToProps = { selectTemplate };

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { producerId } = stateProps;
    const { selectTemplate } = dispatchProps;
    const { specificConsumerId } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        selectTemplate: templateName => selectTemplate({ producerId, templateName, specificConsumerId })
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(TemplatesList);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/templates-list/index.js